import { render, staticRenderFns } from "./CustomerPdfDialog.vue?vue&type=template&id=07f0e1b0&scoped=true&"
import script from "./CustomerPdfDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerPdfDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPdfDialog.vue?vue&type=style&index=0&id=07f0e1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f0e1b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VImg})
